// extracted by mini-css-extract-plugin
export default {"holder":"Experiment_holder__OgHgE"};